/**
 * 过滤对象中的null和undefined
 */
export const filterNullOrUndefined = (obj, isExcludeArray) => {
  if (!(typeof obj === 'object' && obj !== null)) return obj

  if (Array.isArray(obj)) {
    return obj.map(item => filterNullOrUndefined(item, isExcludeArray))
  }

  const filteredObj = {}
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      if (isExcludeArray && Array.isArray(obj[key])) continue
      if (obj[key] !== null && obj[key] !== undefined) {
        // const objValue = Object.prototype.toString.call(obj[key]) === '[object String]' ? obj[key].trim() : obj[key]
        // filteredObj[key] = filterNullOrUndefined(objValue, isExcludeArray)
        filteredObj[key] = filterNullOrUndefined(obj[key], isExcludeArray)
      }
    }
  }
  return filteredObj
}

/**
 * 参数格式化
 */
export const paramsFormat = (isParams, url, data) => {
  const params = url.split('?')[1]
  return isParams ? sortedObject({ ...data, ...Object.fromEntries(new URLSearchParams(params)) }) : JSON.stringify(data) + sortedObject(Object.fromEntries(new URLSearchParams(params)))
}

/**
 * url域名是否localhost
 */
export const isLocalhost = url => {
  const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/
  const match = url.match(domainRegex) || []
  return match[1]?.toLowerCase() === 'localhost'
}

/**
 * 对象排序
 */
const sortedObject = unsortedObject => {
  const keys = Object.keys(unsortedObject)
  const sortedKeys = keys.sort()
  const sortedObject = {}
  sortedKeys.forEach(key => {
    if (unsortedObject[key] === null || unsortedObject[key] === undefined) return
    sortedObject[key] = unsortedObject[key]
  })
  let str = ''
  for (const [key, value] of Object.entries(sortedObject)) {
    str += `&${key}=${value}`
  }
  return str.substring(1)
}
